import SubmissionTranslator from "../../../utils/SubmissionTranslator";
import { baseColumnNameAliases } from "./BaseEncounterClaim";

const translator = new SubmissionTranslator("medical_encounter");

// Order of columnSchema MUST match "order" of columnDetails
export const columnSchema = {
  date_of_service: null,
  ndc: null,
  quantity: null,
  rendering_physician_id: null,
  service_provider_id: null,
  id_340b_raw: null,
  health_plan_id: null,
  health_plan_name: null,
  claim_number: null,
  claim_line_number: null,
  hcpcs_code: null,
  hcpcs_code_modifier_1: null,
  hcpcs_code_modifier_2: null,
  hcpcs_code_modifier_3: null,
  hcpcs_code_modifier_4: null,
  unit_of_measure: null,
  wholesaler_invoice_number: null,
  // start encounter fields
  encounter_billing_service_provider_id: null,
  encounter_date_of_service: null,
  encounter_rendering_physician_id: null,
  encounter_hcpcs_code: null,
  encounter_hcpcs_code_modifier_1: null,
  encounter_hcpcs_code_modifier_2: null,
  encounter_hcpcs_code_modifier_3: null,
  encounter_hcpcs_code_modifier_4: null,
  encounter_diagnosis_code_primary: null,
  encounter_diagnosis_code_2: null,
  encounter_diagnosis_code_3: null,
  encounter_diagnosis_code_4: null,
  encounter_diagnosis_code_5: null,
  encounter_diagnosis_code_6: null,
  encounter_diagnosis_code_7: null,
  encounter_diagnosis_code_8: null,
  encounter_diagnosis_code_9: null,
  encounter_diagnosis_code_10: null,
  encounter_place_of_service_code: null,
  // hashed fields
  formatted_claim_number: null,
};

// Order of columnSchema MUST match "order" of columnDetails
export const columnDetails = [
  {
    name: "date_of_service",
    title: translator.getTitle("date_of_service"),
    label: translator.getLabel("date_of_service"),
    description: translator.getDescription("date_of_service"),
    required: true,
    order: 1,
  },
  {
    name: "ndc",
    title: translator.getTitle("ndc"),
    label: translator.getLabel("ndc"),
    description: translator.getDescription("ndc"),
    required: true,
    order: 2,
  },
  {
    name: "quantity",
    title: translator.getTitle("quantity"),
    label: translator.getLabel("quantity"),
    description: translator.getDescription("quantity"),
    required: true,
    order: 3,
  },
  {
    name: "rendering_physician_id",
    title: translator.getTitle("rendering_physician_id"),
    label: translator.getLabel("rendering_physician_id"),
    description: translator.getDescription("rendering_physician_id"),
    required: false,
    order: 4,
  },
  {
    name: "service_provider_id",
    title: translator.getTitle("service_provider_id"),
    label: translator.getLabel("service_provider_id"),
    description: translator.getDescription("service_provider_id"),
    required: true,
    order: 5,
  },
  {
    name: "id_340b_raw",
    title: translator.getTitle("id_340b_raw"),
    label: translator.getLabel("id_340b_raw"),
    description: translator.getDescription("id_340b_raw"),
    required: true,
    order: 6,
  },
  {
    name: "health_plan_id",
    title: translator.getTitle("health_plan_id"),
    label: translator.getLabel("health_plan_id"),
    description: translator.getDescription("health_plan_id"),
    required: true,
    order: 7,
  },
  {
    name: "health_plan_name",
    title: translator.getTitle("health_plan_name"),
    label: translator.getLabel("health_plan_name"),
    description: translator.getDescription("health_plan_name"),
    required: true,
    order: 8,
  },
  {
    name: "claim_number",
    title: translator.getTitle("claim_number"),
    label: translator.getLabel("claim_number"),
    description: translator.getDescription("claim_number"),
    required: true,
    order: 9,
  },
  {
    name: "claim_line_number",
    title: translator.getTitle("claim_line_number"),
    label: translator.getLabel("claim_line_number"),
    description: translator.getDescription("claim_line_number"),
    required: true,
    order: 10,
  },
  {
    name: "hcpcs_code",
    title: translator.getTitle("hcpcs_code"),
    label: translator.getLabel("hcpcs_code"),
    description: translator.getDescription("hcpcs_code"),
    required: false,
    order: 11,
  },
  {
    name: "hcpcs_code_modifier_1",
    title: translator.getTitle("hcpcs_code_modifier_1"),
    label: translator.getLabel("hcpcs_code_modifier_1"),
    description: translator.getDescription("hcpcs_code_modifier_1"),
    required: false,
    order: 12,
  },
  {
    name: "hcpcs_code_modifier_2",
    title: translator.getTitle("hcpcs_code_modifier_2"),
    label: translator.getLabel("hcpcs_code_modifier_2"),
    description: translator.getDescription("hcpcs_code_modifier_2"),
    required: false,
    order: 13,
  },
  {
    name: "hcpcs_code_modifier_3",
    title: translator.getTitle("hcpcs_code_modifier_3"),
    label: translator.getLabel("hcpcs_code_modifier_3"),
    description: translator.getDescription("hcpcs_code_modifier_3"),
    required: false,
    order: 14,
  },
  {
    name: "hcpcs_code_modifier_4",
    title: translator.getTitle("hcpcs_code_modifier_4"),
    label: translator.getLabel("hcpcs_code_modifier_4"),
    description: translator.getDescription("hcpcs_code_modifier_4"),
    required: false,
    order: 15,
  },
  {
    name: "unit_of_measure",
    title: translator.getTitle("unit_of_measure"),
    label: translator.getLabel("unit_of_measure"),
    description: translator.getDescription("unit_of_measure"),
    required: false,
    order: 16,
  },
  {
    name: "wholesaler_invoice_number",
    title: translator.getTitle("wholesaler_invoice_number"),
    label: translator.getLabel("wholesaler_invoice_number"),
    description: translator.getDescription("wholesaler_invoice_number"),
    required: false,
    order: 17,
  },
  {
    name: "encounter_billing_service_provider_id",
    title: translator.getTitle("encounter_billing_service_provider_id"),
    label: translator.getLabel("encounter_billing_service_provider_id"),
    description: translator.getDescription("encounter_billing_service_provider_id"),
    required: false,
    order: 18,
  },
  {
    name: "encounter_date_of_service",
    title: translator.getTitle("encounter_date_of_service"),
    label: translator.getLabel("encounter_date_of_service"),
    description: translator.getDescription("encounter_date_of_service"),
    required: false,
    order: 19,
  },
  {
    name: "encounter_rendering_physician_id",
    title: translator.getTitle("encounter_rendering_physician_id"),
    label: translator.getLabel("encounter_rendering_physician_id"),
    description: translator.getDescription("encounter_rendering_physician_id"),
    required: false,
    order: 20,
  },
  {
    name: "encounter_hcpcs_code",
    title: translator.getTitle("encounter_hcpcs_code"),
    label: translator.getLabel("encounter_hcpcs_code"),
    description: translator.getDescription("encounter_hcpcs_code"),
    required: false,
    order: 21,
  },
  {
    name: "encounter_hcpcs_code_modifier_1",
    title: translator.getTitle("encounter_hcpcs_code_modifier_1"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_1"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_1"),
    required: false,
    order: 22,
  },
  {
    name: "encounter_hcpcs_code_modifier_2",
    title: translator.getTitle("encounter_hcpcs_code_modifier_2"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_2"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_2"),
    required: false,
    order: 23,
  },
  {
    name: "encounter_hcpcs_code_modifier_3",
    title: translator.getTitle("encounter_hcpcs_code_modifier_3"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_3"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_3"),
    required: false,
    order: 24,
  },
  {
    name: "encounter_hcpcs_code_modifier_4",
    title: translator.getTitle("encounter_hcpcs_code_modifier_4"),
    label: translator.getLabel("encounter_hcpcs_code_modifier_4"),
    description: translator.getDescription("encounter_hcpcs_code_modifier_4"),
    required: false,
    order: 25,
  },
  {
    name: "encounter_diagnosis_code_primary",
    title: translator.getTitle("encounter_diagnosis_code_primary"),
    label: translator.getLabel("encounter_diagnosis_code_primary"),
    description: translator.getDescription("encounter_diagnosis_code_primary"),
    required: false,
    order: 26,
  },

  {
    name: "encounter_diagnosis_code_2",
    title: translator.getTitle("encounter_diagnosis_code_2"),
    label: translator.getLabel("encounter_diagnosis_code_2"),
    description: translator.getDescription("encounter_diagnosis_code_2"),
    required: false,
    order: 27,
  },
  {
    name: "encounter_diagnosis_code_3",
    title: translator.getTitle("encounter_diagnosis_code_3"),
    label: translator.getLabel("encounter_diagnosis_code_3"),
    description: translator.getDescription("encounter_diagnosis_code_3"),
    required: false,
    order: 28,
  },
  {
    name: "encounter_diagnosis_code_4",
    title: translator.getTitle("encounter_diagnosis_code_4"),
    label: translator.getLabel("encounter_diagnosis_code_4"),
    description: translator.getDescription("encounter_diagnosis_code_4"),
    required: false,
    order: 29,
  },
  {
    name: "encounter_diagnosis_code_5",
    title: translator.getTitle("encounter_diagnosis_code_5"),
    label: translator.getLabel("encounter_diagnosis_code_5"),
    description: translator.getDescription("encounter_diagnosis_code_5"),
    required: false,
    order: 30,
  },
  {
    name: "encounter_diagnosis_code_6",
    title: translator.getTitle("encounter_diagnosis_code_6"),
    label: translator.getLabel("encounter_diagnosis_code_6"),
    description: translator.getDescription("encounter_diagnosis_code_6"),
    required: false,
    order: 31,
  },
  {
    name: "encounter_diagnosis_code_7",
    title: translator.getTitle("encounter_diagnosis_code_7"),
    label: translator.getLabel("encounter_diagnosis_code_7"),
    description: translator.getDescription("encounter_diagnosis_code_7"),
    required: false,
    order: 32,
  },
  {
    name: "encounter_diagnosis_code_8",
    title: translator.getTitle("encounter_diagnosis_code_8"),
    label: translator.getLabel("encounter_diagnosis_code_8"),
    description: translator.getDescription("encounter_diagnosis_code_8"),
    required: false,
    order: 33,
  },
  {
    name: "encounter_diagnosis_code_9",
    title: translator.getTitle("encounter_diagnosis_code_9"),
    label: translator.getLabel("encounter_diagnosis_code_9"),
    description: translator.getDescription("encounter_diagnosis_code_9"),
    required: false,
    order: 34,
  },
  {
    name: "encounter_diagnosis_code_10",
    title: translator.getTitle("encounter_diagnosis_code_10"),
    label: translator.getLabel("encounter_diagnosis_code_10"),
    description: translator.getDescription("encounter_diagnosis_code_10"),
    required: false,
    order: 35,
  },
  {
    name: "encounter_place_of_service_code",
    title: translator.getTitle("encounter_place_of_service_code"),
    label: translator.getLabel("encounter_place_of_service_code"),
    description: translator.getDescription("encounter_place_of_service_code"),
    required: false,
    order: 36,
  },
];

export const computedColumns = ["formatted_claim_number"];

export const tableHeaders = columnDetails.sort((a, b) => a.order - b.order).map((col) => col.name);
export const sortedColumnDetails = columnDetails.sort((a, b) => a.order - b.order);
export const required = columnDetails.filter((col) => col.required).map((col) => col.name);
export const notRequired = columnDetails.filter((col) => !col.required).map((col) => col.name);

export const isRequiredField = (column) => required.includes(column);

// Medical-specific column name aliases merged with base encounter aliases
export const columnNameAliases = {
  // Import all base aliases (encounter fields + common fields)
  ...baseColumnNameAliases,

  // Medical-specific field aliases
  rendering_physician_id: [
    "Rendering Physician NPI",
    "Rendering Physician ID",
    "Rendering Provider NPI",
  ],
  id_340b_raw: ["Contracted Entity ID", "CE ID", "Entity ID", "OPA Code", "HRSA #", "340B ID"],
  health_plan_id: ["Health Plan ID", "Plan ID Code", "Plan Identifier"],
  health_plan_name: ["Health Plan Name", "Plan Name"],
  claim_number: ["Claim Number", "Claim ID", "Claim Unique ID"],
  claim_line_number: ["Claim Line Number", "Line Number", "Line No"],
  hcpcs_code: ["HCPCS Code", "HCPC Code", "HCPC CD", "J Code"],
  hcpcs_code_modifier_1: ["HCPCS Code Modifier 1", "HCPCS Modifier 1", "J Code Modifier 1"],
  hcpcs_code_modifier_2: ["HCPCS Code Modifier 2", "HCPCS Modifier 2", "J Code Modifier 2"],
  hcpcs_code_modifier_3: ["HCPCS Code Modifier 3", "HCPCS Modifier 3", "J Code Modifier 3"],
  hcpcs_code_modifier_4: ["HCPCS Code Modifier 4", "HCPCS Modifier 4", "J Code Modifier 4"],
  unit_of_measure: ["Unit of Measure", "Billed HCPCS Unit of Measure"],
};
